import { VerifierRoutes } from 'src/routes'
import RoleLayout from './RoleLayout'

const VerifierLayout = () => <RoleLayout allowedProfile="Verifier" routes={VerifierRoutes} />

export default VerifierLayout
